import React, { useEffect } from "react";
import { Box, Typography, Paper, Divider, Button } from "@mui/material";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import FuseLoading from "@fuse/core/FuseLoading";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { getReportById, selectReportById } from "../../reports/store/reportSlice";

const ViewReportGeneralDrowsiness = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const { reportId } = params;
  const report = useSelector((state) => selectReportById(state, reportId));

  useEffect(() => {
    dispatch(getReportById(reportId));
  }, [dispatch, reportId]);

  if (!report) return <FuseLoading />;

  const generalAnswers = report.answers.filter(
    (a) => a.question_name.toUpperCase() === "ASPECTOS GENERALES"
  );

  const handleBack = () => history.back();

  return (
    <Box p={3}>
      {/* 🔙 Volver */}
      <Button
        style={{ marginBottom: "10px" }}
        variant="contained"
        color="info"
        onClick={handleBack}
        size="small"
        startIcon={<FuseSvgIcon size={20}>material-solid:arrow_back</FuseSvgIcon>}
      >
        Volver
      </Button>

      {/* 🧾 Encabezado */}
      <Typography variant="h4" align="center" sx={{ fontWeight: "bold", mb: 1 }}>
        {report.name}: {report.code}
      </Typography>
      <Typography align="center" variant="subtitle1" gutterBottom>
        Realizada por <strong>{report.user_name}</strong>
      </Typography>

      {/* <Button
        variant="outlined"
        size="small"
        color="primary"
        sx={{ mb: 3 }}
        onClick={() => exportImagesReport(report, generalAnswers)}
      >
        Exportar PDF
      </Button> */}

      {/* 📋 Listado de respuestas */}
      <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold", mb: 2 }}>
          Aspectos Generales
        </Typography>

        {generalAnswers.map((answer, index) => (
          <Box
            key={answer.id}
            sx={{
              mb: 3,
              p: 2,
              borderRadius: 2,
              backgroundColor: index % 2 === 0 ? "grey.50" : "white",
              borderLeft: "4px solid",
              borderColor: "primary.main",
            }}
          >
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
              {index + 1}. {answer.name}
            </Typography>

            <Typography variant="body1" sx={{ ml: 1 }}>
              <strong>Respuesta:</strong> {answer.question_value || "—"}
            </Typography>

            {answer.metadata && (
              <Typography variant="body2" sx={{ ml: 1, mt: 1, color: "text.secondary" }}>
                <strong>Comentarios:</strong> {answer.metadata.comment}
              </Typography>
            )}

            {answer.question_type === "photo" && answer.question_value && (
              <Box sx={{ textAlign: "center", mt: 2 }}>
                <img
                  src={answer.question_value}
                  alt={answer.name}
                  style={{
                    maxWidth: "100%",
                    borderRadius: "10px",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                  }}
                />
              </Box>
            )}

            <Divider sx={{ mt: 2 }} />
          </Box>
        ))}
      </Paper>
    </Box>
  );
};

export default ViewReportGeneralDrowsiness;
